export const RECOVERABLE_AUDIO_CONTEXT_STATES = Object.freeze(['suspended', 'interrupted']);
export const AUDIO_CONTEXT_RESUME_TIMEOUT_MS = 2500;

export function audioContextNeedsReplacement(context) {
  return !context || context.state === 'closed';
}

export async function ensureAudioContextRunning(context, { setTimer = setTimeout, clearTimer = clearTimeout, onResumeSettled } = {}) {
  if (!context || context.state === 'closed') return false;
  if (context.state === 'running') return true;
  if (!RECOVERABLE_AUDIO_CONTEXT_STATES.includes(context.state) || typeof context.resume !== 'function') return false;
  let timer;
  try {
    // Call resume synchronously so a Replay tap retains browser user activation.
    // Some browsers leave this promise pending until a future gesture.
    return await Promise.race([
      Promise.resolve(context.resume()).then(() => {
        // This still runs when the deadline won, so callers can reassert a
        // newer Pause after the browser physically resumes an old request.
        onResumeSettled?.();
        return context.state === 'running';
      }),
      new Promise(resolve => { timer = setTimer(() => resolve(false), AUDIO_CONTEXT_RESUME_TIMEOUT_MS); }),
    ]);
  } finally { clearTimer(timer); }
}
